import { SceneSchema } from '@common/schemas/scene.schema';
import { AuditSchema } from '@common/schemas/entities/shared.schema';
import { WriterRoomStatusSchema } from '@common/schemas/room-status.schema';
import { z } from 'zod';

/**
 * Scene Form schema.
 * Extends Common SceneSchema with UI-only fields.
 */
export const SceneFormSchema = SceneSchema.extend({
  id: z.string().optional(),
  audit: AuditSchema.optional(),
  status: WriterRoomStatusSchema.optional(),
}).passthrough();

export type SceneFormValues = z.infer<typeof SceneFormSchema>;
